import RoutesMap from "../../route_control/RouteControl"
import {
    GroupTypeList,
    AddGroupType,
    UpdateGroupType,
    GroupList,
    AddGroup,
    UpdateGroup,
    DepartmentList,
    AddDepartment,
    UpdateDepartment,
    EmployeeList,
    AddEmployee,
    UpdateEmployee
} from "../../pages/hr"

export const HRImport = {
    RoutesMap,
    GroupTypeList,
    AddGroupType,
    UpdateGroupType,
    GroupList,
    AddGroup,
    UpdateGroup,
    DepartmentList,
    AddDepartment,
    UpdateDepartment,
    EmployeeList,
    AddEmployee,
    UpdateEmployee,
}